<template>
  <v-container fluid class="pa-0 pl-2 pt-2" id="dashboard_container">
<!--    <div v-if="isFree" class="text-center mb-3 dunkelblau&#45;&#45;text" style="width: 100%;">-->
<!--      Silber-Abo gratis Test {{ expirationInfo }}-->
<!--    </div>-->
    <div>
      <week-paginator :date="date" :nr="bereichNr" base-url="/dashboard/" class="mr-2 mb-2"></week-paginator>

      <CenterContainer v-if="isPause">
        <div class="text-center">
          <v-icon class="ml-3" color="dunkelblau" size="50px">mdi-sleep</v-icon>
          <div class="my-1 dunkelblau--text">Die Woche ist pausiert</div>
        </div>
      </CenterContainer>

      <index-week v-if="bereichNr===undefined" :date="date" :index="week_index.index" :happyness="week_index.happyness"
                  :lastWeekIndex="lastWeekIndex" :activityTotals="activityTotals"
                  :loading="loading" class="mr-2 mb-2"></index-week>

      <div class="ml-5 mr-5 mt-5" v-if="hinweis">
        <p>
          <b>Achtung: Du hast noch keine Aktivitäten angelegt!</b>
        </p>
        <p>
          Damit du profitieren kannst, musst du deine <router-link class="blue--text" to="/erfolgsmatrix">Lebensziele festlegen</router-link> und deine <router-link class="blue--text" to="/activities">Aktivitäten definieren</router-link>.
          Nimm dir bitte kurz dafür Zeit!
        </p>
        <p>
          Wenn du alles eingerichtet hast, brauchst du nur mehr deine Aktivitäten <router-link class="blue--text" to="/activities">eingeben</router-link>.
          <b>Wenige Minuten pro Tag</b> reichen und du hast den vollen Überblick!
        </p>
      </div>

      <sub-content-switcher v-model="subContentIndex" v-if="bereichNr===undefined"/>

      <div v-if="bereichNr===undefined && subContentIndex===0" class="d-flex flex-row flex-wrap">
        <bereich-week v-for="(bereich,i) in bereiche" :nr="i" :index="week_index[bereich]" :date="date"
                      :bereich="bereich" :lastWeekIndex="lastWeekIndex" :activityTotals="activityTotals"
                      :key="bereich" :loading="loading" v-if="isBereichShown(bereich)"/>
        <!--      <num-value-week :date="date" :activity="activity"  v-for="(activity,i) in validActivities" :key="i"/>-->
      </div>
      <template v-if="bereichNr!==undefined">
        <v-row class="d-flex justify-space-between ml-0 mr-2">
          <v-btn class="mb-2" :to="toOverview">Zur Übersicht</v-btn>
          <v-btn v-if="bereiche.length > 1" class="mb-2" :to="toNext">{{ nextBereich }}</v-btn>
        </v-row>
        <bereich-week :index="week_index[b]" :bereich="b" :key="b" :loading="loading" :lastWeekIndex="lastWeekIndex" :activityTotals="activityTotals"/>
        <sub-content-switcher v-model="subContentIndex" class="mr-2"/>
        <div class="d-flex flex-row flex-wrap" v-if="subContentIndex===0">
          <num-value-week :date="date" :activity="activity" v-for="(activity,i) in validActivities"
                          :key="activity.id" :targets="targets" :activitySums="activitySums" :lastWeekActivitySums="lastWeekActivitySums"
                          :activityTotals="activityTotals"
                          />
        </div>
      </template>
      <comments v-if="subContentIndex===1" :date="date" :bereich="b||'all'"/>
      <!--    restriktionshinweis-->
    </div>
<!--    <div v-if="(isFree)" class="text-xl-center">-->
<!--      <div class="mt-3 pa-3 dunkelblau lighten-1 white&#45;&#45;text text&#45;&#45;darken-3 mb-3"-->
<!--           style="border: 1px dashed gray; width: calc( 100% - 8px); height: 200px; border-radius: 5px;">-->
<!--        <span class="headline">Jetzt Abonnieren!</span>-->
<!--        <br/><br/> Das-->
<!--        <a class="gelb&#45;&#45;text" href="https://www.digistore24.com/product/410225" target="_blank">Silber-Abo</a>-->
<!--        für insgesamt 5 Lebensbereiche und bis zu 10 Aktivitäten.<br><br> Oder das-->
<!--        <a class="gelb&#45;&#45;text" href="https://www.digistore24.com/product/410225" target="_blank">Gold-Abo</a>-->
<!--        für insgesamt 10 Lebensbereiche und bis zu 100 Aktivitäten.-->
<!--      </div>-->
<!--    </div>-->
    <div v-if="(isFree)" class="text-xl-center mb-3">
      <div class="mt-3 pa-3"
           style="border: 1px dashed dodgerblue; width: calc( 100% - 8px); height: 270px; border-radius: 5px; background-color: #ffffff30">
        <span class="headline">Mehr Lebensäulen oder Aktivitäten?</span>
        <br/><br/> Go <pro/> für insgesamt 10 Lebensbereiche bis zu 100 Aktivitäten, SMS-Erinnerung, Zähler und Stoppuhr!
        <br/><br/>
        <v-btn rounded class="d-flex mx-10 dunkelblau--text gelb" href="https://www.digistore24.com/product/410225"
               target="_blank">Upgrade auf aimz PRO</v-btn>
      </div>
    </div>
    <div class="d-flex">
      <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/hfk7_hXIWK8" target="_blank">
        <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import BereichWeek from "@/components/Charts/BereichWeek";
import IndexWeek from "@/components/Charts/IndexWeek";
import Kinds from "@/components/Kinds";
import Bereiche from "@/components/Bereiche";
import NumValueWeek from "@/components/Charts/NumValueWeek";
import BereichIndexWeek2 from "@/components/Charts/BereichIndexWeek2";
import ActivityLibrary from "@/components/ActivityLibrary";
import WeekPaginator from "@/components/Charts/WeekPaginator";
import {convertToInt} from "@/reusable/typeconversion";
import SubContentSwitcher from "@/components/Charts/SubContentSwitcher";
import Comments from "@/components/Comments";
import {ArrayX} from "@/reusable/array_extensions";
import {Ziele} from "@/components/Ziele";
import Datum from "@/components/Datum";
import Duration from "luxon/src/duration.js";
import Pro from "@/components/Pro";


const {DateTime} = require("luxon");

export default {
  name: "Dashboard",
  components: {Comments, SubContentSwitcher, WeekPaginator, NumValueWeek, IndexWeek, BereichIndexWeek2, BereichWeek, Pro},
  data() {
    return {
      hinweis:false,
      date: undefined,
      dateTime: undefined,
      isodate: undefined,
      lastWeekDate:undefined,
      lastWeekdateTime:undefined,
      lastWeekdateisodate:undefined,
      subContentIndex: 0,
      week_index: {},
      lastWeekIndex: undefined,
      activities: [],
      //week_index_only: [],
      loading: false,
      bereichNr: undefined,
      b: undefined,
      nextBereich: undefined,
      targets: undefined,
      currentTargets: undefined,
      activitySums: {},
      lastWeekActivitySums: undefined,
      activityTotals: undefined,
    }
  },
  mounted() {
    this.routeChanged(this.$route);
    this.$events.$on("lobbyRouteChanged", this.routeChanged);
    this.reload();
  },
  destroyed() {
    this.$events.$off("lobbyRouteChanged", this.routeChanged)
  },
  methods: {
    routeChanged(route) {
      if (route.params.date)
        this.date = new Date(route.params.date);
      else
        this.date = new Date(Date.now());
      this.updateDateTime();
      if (route.params.bereichNr) {
        this.bereichNr = convertToInt(route.params.bereichNr);
        this.b = this.getBereich();
        this.nextBereich = this.getNextBereich();
      } else {
        this.bereichNr = undefined;
        this.b = undefined;
        this.nextBereich = undefined;
      }
    },
    updateDateTime() {
      var dateTime = DateTime.fromJSDate(this.date).setLocale("de");
      console.log({date: this.date, dateTime, weekday: dateTime.weekday});
      if (dateTime.weekday != 1)
        dateTime = dateTime.startOf("week");
      console.log("after weekstart", {dateTime})
      this.dateTime = dateTime;
      this.date = dateTime.toJSDate();
      this.isodate = this.dateTime.toISODate();
      this.lastWeekdateTime = dateTime.minus(Duration.fromObject({days:7}));
      this.lastWeekDate =  this.lastWeekdateTime.toJSDate();
      this.lastWeekIsodate = this.lastWeekdateTime.toISODate();
    },
    async reload() {
      this.loading = true;
      this.updateDateTime();
      console.log("dashboard: " + this.isodate);
      this.week_index = await this.$backend.get_object(Kinds.KIND_INDEX, this.isodate);
      this.week_index ||= {};
      this.loading = false;
        var activities = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY);
        if (!activities)
          return;
        activities.forEach(x => x.sortKey ||= 0);
        activities = ActivityLibrary.filterActivitiesByDate(activities, this.dateTime);
      if (this.b)
        this.activities = new ArrayX(activities.filter(a => a.bereich == this.b)).sortBy(a => a.sortKey);
      else
        this.activities = new ArrayX(activities.filter(a => a.name)).sortBy(a => a.sortKey);
      if (this.activities.length === 0)
        this.hinweis=true;
      this.activitySums = (await this.$backend.get_object(Kinds.KIND_ACTIVITY_SUMS, this.isodate) || {});
      this.targets = (await this.$backend.get_object(Kinds.KIND_ZIELE, Ziele.makeId(this.dateTime.year)) || {});
      this.currentTargets = new Ziele(this.targets).getCurrentTargets();
      // for trends
      this.lastWeekIndex = await this.$backend.get_object(Kinds.KIND_INDEX, this.lastWeekIsodate);
      this.lastWeekActivitySums = (await this.$backend.get_object(Kinds.KIND_ACTIVITY_SUMS, this.lastWeekIsodate) || {});
      // for avg
      this.activityTotals = (await this.$backend.get_object(Kinds.KIND_ACTIVITY_TOTALS, this.lastWeekIsodate) || {});
    },
    isBereichShown(bereich) {
      return this.$app.isBereichShown(bereich);
    },
    getBereich() {
      if (this.bereichNr === undefined)
        return undefined;
      return this.bereiche[this.bereichNr];
    },
    getNextBereich() {
      if (this.bereichNr === undefined)
        return undefined;
      return this.$app.getBereichName(this.bereiche[(this.bereichNr + 1) % this.bereiche.length]);
    },
    getCurrentTarget(activity) {
      if (!this.currentTargets)
        return 1;
      if (this.currentTargets[activity.id])
        return this.currentTargets[activity.id];
      return undefined;
    },
  },
  computed: {
    bereiche() {
      return this.$app.bereiche.map(x => x.bid);
    },
    validActivities() {
      return this.activities.filter(a => a.name && (this.getCurrentTarget(a) || 0) > 0 || (a.type === ActivityLibrary.TYPE_BOOL && a.freq === ActivityLibrary.FREQ_DAILY));
    },
    toOverview() {
      return '/dashboard/' + this.isodate;
    },
    toNext() {
      return '/dashboard/' + this.isodate + '/' + ((this.bereichNr + 1) % this.bereiche.length);
    },
    isFree() {
      return this.$app.isFree;
    },
    isSilver() {
      return this.$app.isSilver;
    },
    isGold() {
      return this.$app.isGold;
    },
    // expirationInfo() {
    //   return this.$app.expirationInfo;
    // },
    // isExpired() {
    //   return this.$app.isExpired;
    // },
    isPause() {
      return this.week_index.pause;
    }
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.date)
        this.date = new Date(this.$route.params.date);
      this.reload();
    }
  }
}
</script>

<style scoped>

</style>